import script from "./side-bar-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./side-bar-button.vue?vue&type=script&lang=ts&setup=true"

import "./side-bar-button.vue?vue&type=style&index=0&id=48893c44&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48893c44"]])

export default __exports__